/* eslint-disable indent */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { GenericFormFields } from '../interfaces';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { get } from 'lodash';

const GenericFormTextField: React.FC<GenericFormFields> = ({
  item,
  fields,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const initialValue = fields?.[item.stateKey] || values?.[item.stateKey] || '';

  const [value, setValue] = React.useState<any>(initialValue);

  const field = get(fields, item.stateKey, null);

  React.useEffect(() => {
    field ? setValue(field) : setValue('');
  }, [fields, field]);

  const [showPassword, setShowPw] = React.useState<boolean>(false);

  const getPasswordFieldType = showPassword ? 'text' : 'password';

  if (item.stateKey === '' && item.label === '') return <Grid item xs={12} />;

  return (
    <TextField
      key={item.stateKey}
      name={item.stateKey}
      value={value}
      onChange={e => {
        if (item.validateOnChange) {
          setFieldValue && setFieldValue(item.stateKey, e.target.value);
          setValue(e.target.value);
        }
        setValue(e.target.value);
      }}
      onBlur={e => {
        if (setFieldValue) setFieldValue(item.stateKey, e.target.value);
        if (changeField)
          changeField({
            key: item.stateKey,
            value: Object(item).hasOwnProperty('id')
              ? { id: item.id, value: e.target.value }
              : e.target.value,
          });
      }}
      fullWidth
      type={item.isPassword ? getPasswordFieldType : item.type ?? ''}
      variant="outlined"
      label={item.label}
      disabled={item.disabled}
      error={
        !!get(errors, item.stateKey, null) || !!get(errors, item.error, null)
      }
      helperText={
        get(errors, item.stateKey, null) || get(errors, item.error, null)
      }
      InputProps={
        item.isPassword || item?.tooltip
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  {item?.tooltip ? (
                    item.tooltip
                  ) : (
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPw(!showPassword)}
                      onMouseDown={e => e.preventDefault()}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};

export default GenericFormTextField;
